export const artisans = [
  {
    id: "a-margaret",
    name: "Margaret Holloway",
    craft: "Quilter & Textile Maker",
    location: "Galena, Illinois",
    years: 22,
    portrait:
      "https://readdy.ai/api/search-image?query=Portrait%20of%20a%20warm%20smiling%20woman%20in%20her%20fifties%20with%20gray%20streaked%20hair%20wearing%20a%20cream%20linen%20apron%2C%20sitting%20by%20a%20bright%20farmhouse%20window%20holding%20a%20folded%20patchwork%20quilt%2C%20soft%20natural%20morning%20light%2C%20editorial%20documentary%20photography%20with%20a%20muted%20cream%20and%20sage%20color%20palette%20and%20simple%20clean%20background&width=900&height=1100&seq=artisan-margaret-01&orientation=portrait",
    quote:
      "Every quilt I stitch carries a little piece of my grandmother's porch and the lullabies she sang on warm Iowa evenings.",
    kids: 3,
  },
  {
    id: "a-ruth",
    name: "Ruth Anderson",
    craft: "Stoneware Potter",
    location: "Decorah, Iowa",
    years: 14,
    portrait:
      "https://readdy.ai/api/search-image?query=Portrait%20of%20a%20kind%20looking%20woman%20in%20her%20forties%20with%20her%20hair%20tied%20back%20wearing%20a%20clay%20stained%20linen%20apron%20inside%20a%20bright%20home%20pottery%20studio%2C%20holding%20a%20honey%20glazed%20stoneware%20mug%2C%20soft%20natural%20window%20light%2C%20editorial%20documentary%20photography%20with%20a%20muted%20cream%20and%20honey%20color%20palette%20and%20simple%20clean%20background&width=900&height=1100&seq=artisan-ruth-02&orientation=portrait",
    quote:
      "Clay teaches patience. My boys learned to roll their first coil pot before they could tie their shoes.",
    kids: 2,
  },
  {
    id: "a-eleanor",
    name: "Eleanor Briggs",
    craft: "Hand-Lettering Artist",
    location: "Stillwater, Minnesota",
    years: 9,
    portrait:
      "https://readdy.ai/api/search-image?query=Portrait%20of%20a%20cheerful%20woman%20in%20her%20thirties%20with%20curly%20auburn%20hair%20wearing%20a%20simple%20cream%20sweater%2C%20sitting%20at%20a%20bright%20wooden%20desk%20with%20hand%20lettering%20supplies%20and%20a%20painted%20wooden%20sign%2C%20soft%20natural%20window%20light%2C%20editorial%20documentary%20photography%20with%20a%20muted%20cream%20and%20terracotta%20color%20palette%20and%20simple%20clean%20background&width=900&height=1100&seq=artisan-eleanor-03&orientation=portrait",
    quote:
      "I letter every sign while my daughter naps. Each stroke is a little quiet prayer for the home it's headed to.",
    kids: 1,
  },
];